import getCreditCardURL, { CC_URL_SLUGS } from '../functions/getCreditCardURL';


/**
 * get language-specific landing page for a CC network
 * @param {object} cardInfo
 * @param {string} cardInfo.network EN slug of CC network
 * @param {string} language en or fr
 * @return {string} path to RH page for the given CC network
 */
export default function getCardNetworkLandingPage({ network }, language) {
    return getCreditCardURL(language, CC_URL_SLUGS.BASE, network);
}
